import {ProjectsAPI} from '@3cad/nextcore';
import {hasOwnProperty} from 'bootstrap-vue/esm/utils/object'

export const commonStore = {
    state: {
        logs: [],
        shops:[],
        cats:[],
        err:{

        },
        loading: false,
        msgLoading: null,
        percLoading: null,
        loaderTimeOut: null,
        translations: {},
        mustSaveTrans: false,
        profile: null,
        guestProfile: null,
        shop: null,
        notifications: [],
        preferences: {},
        /** Coefficiente di maggiorazione globale di tutta l'applicazione next
         * Di default vale 1, in questo modo i prezzi restano invariati per tutti i clienti
         */
        pricesIncrease: 1,
        intoIframe: false,
        maintenance: {
            isMaintenance: false,
            startDateTimeUTC: null,
            endDateTimeUTC: null
        }
    },
    mutations: {
        /** Reset application loader
         * @param state
         */
        resetLoading(state) {
            state.loading = false;
            state.msgLoading = null;
            state.percLoading = null;
            clearTimeout( state.loaderTimeOut );
            state.loaderTimeOut = null;
        },
        /** Start application loader
         * @param state
         * @param msg
         * @param perc
         */
        startLoading(state, { msg, perc }) {
            state.loading = true;
            if(msg)
                state.msgLoading = msg;
            if(!isNaN(perc))
                state.percLoading = perc;

            state.loading = true;

            if(state.loaderTimeOut !== null)
                clearTimeout( state.loaderTimeOut );

            state.loaderTimeOut = setTimeout(() => {
                this.commit('resetLoading');
                console.error('Kill loader by timeout');
            }, 60*1000);
        },
        setTranslations(state, translations) {
            if(translations) {
                // console.log('Translations', translations);
                state.translations = Object.assign({}, translations)
            }
        },
        setProfile(state, profile) {
            state.profile = profile;
            if (profile && profile.shop && Object.keys(profile.shop).length > 1)
                state.shop = state.profile.shop;
            else
                state.shop = null;
        },
        setGuestProfile(state, profile) {
            state.guestProfile = profile;
        },
        setShop(state, shop) {
            state.shop = shop;
        },
        setPreferences(state, preferences) {
            Object.assign(state.preferences, preferences);
        },
        setPricesIncrease(state, coeff) {
            let newCoeff = Number(coeff);
            state.pricesIncrease = isNaN(newCoeff) ? 1 : newCoeff;
            state.preferences.config.pricesIncrease = state.pricesIncrease;
        },
        setIntoIframe(state, status) {
            state.intoIframe = status;
        },
        setMantainance(state, {
            isMaintenance = false,
            startDateTimeUTC,
            endDateTimeUTC
        }) {
            state.maintenance.isMaintenance = isMaintenance
            state.maintenance.startDateTimeUTC = startDateTimeUTC
            state.maintenance.endDateTimeUTC = endDateTimeUTC
        }
    },
    getters: {
        catalogs(state) {
            let c=[];
            state.cats.forEach(e => {
                if (!e.local) {
                    c.push(e.cod.toLowerCase());
                }
            });
            return c;
        },
        catalog: (state) => (name) => {
            name=name.trim().toLowerCase();
            var x=state.cats.find(x => !x.local && x.cod.toLowerCase()==name);
            if (x==null) x={cod:name};
            return x;
        },
        loading(state) {
            return {
                loading: state.loading,
                message: state.msgLoading,
                percentage: state.percLoading
            }
        },
        translate: (state) => (text) => {
            if(text) {
                if(typeof(text) === "string") {
                    let key = text.toLowerCase().trim()
                    // console.log('Translate %c'+ key, 'color: orange');

                    // Return translation
                    if(state.translations[key])
                        return state.translations[key];

                    state.translations[key] = '';
                    state.mustSaveTrans = true;
                    return text;
                }
                else {
                    console.error('Parameter is not a string, can\'t perform a translate', text);
                    return text;
                }
            }
            return text;
        },
        getProfile(state) {
            return state.profile;
        },
        getShop(state) {
            return state.shop;
        },
        getPreferences(state) {
            return state.preferences;
        },
        getGuestProfile(state) {
            return state.guestProfile;
        },
        getNotifications(state) {
            return state.notifications;
        },
        // TODO: Remove with new config.json file
        getConfig(state) {
            if (state.preferences && state.preferences.config)
                return state.preferences.config;
            else
                return {};
        },
        getDclasses(state) {
            if (state.preferences && state.preferences.dclass)
                return state.preferences.dclass;
            else
                return {};
        },
        getPrints(state) {
            if (state.preferences && state.preferences.printings)
                return state.preferences.printings;
            else
                return {};
        },
        getPricesIncrease(state) {
            return state.pricesIncrease
        },
        getIntoIframe(state){
            return state.intoIframe;
        },
        isMaintenance(state) {
            return state.maintenance.isMaintenance
        },
        isMaintenanceBooked(state) {
            return !!state.maintenance.startDateTimeUTC
        }
    },
    actions: {
        updateNotifications(context) {
            ProjectsAPI.notifications(json => {
                context.state.notifications = json;
            });
        },
        deleteNotifications(context, {rowId}) {
            return new Promise((resolve, reject) => {
                ProjectsAPI.deleteNotifications(rowId, json => {
                    context.state.notifications = json;
                });
            })
        },
        logpush(context,lg) {
            var xx=context.state.logs;
            xx.unshift(lg);
            if (xx.length>100) xx.length=100;
        },
        logclear(context ) {
            context.state.logs=[];
        },
        catset(context,cats) {
            context.state.cats=cats;
        },
        storeset(context,shops) {
            context.state.shops=shops;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_eng/store/commonStore.js